// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const OneAgentSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="OneAgentSignetIcon" ref={forwardedRef} {...props}>
      <path d="m14.304 7.32-.333-4.042a1.2 1.2 0 0 0-.599-.96l-.722-.4A3.4 3.4 0 0 0 11.03 1.5H8.97a3.34 3.34 0 0 0-1.622.423L6.626 2.322c-.338.183-.563.55-.599.96L5.694 7.32C5.664 7.655 5.832 7.974 6.11 8.113l3.493 1.79a.86.86 0 0 0 .798 0l3.493-1.79c.272-.14.44-.458.41-.793m-1.298-.24-1.32.446a.54.54 0 0 1-.606-.191l-.526-.67a.71.71 0 0 0-.551-.279.7.7 0 0 0-.552.279l-.525.67A.54.54 0 0 1 8.32 7.526L6.992 7.08C6.666 6.968 6.455 6.625 6.485 6.25l.177-1.94h6.678l.178 1.941c.025.375-.186.717-.512.829m.86 6.384-3.341 2.017a1 1 0 0 1-.523.148A1 1 0 0 1 9.48 15.48l-3.341-2.016a.4.4 0 0 0-.196.354v.288a.84.84 0 0 0 .221.574l3.44 3.64a.54.54 0 0 0 .804 0l3.44-3.64a.84.84 0 0 0 .22-.574V13.82a.44.44 0 0 0-.202-.356" />
      <path d="m5.863 11.156-.127.028C5.598 11.212 5.5 11.344 5.5 11.499v.359a.57.57 0 0 0 .265.49l3.885 2.344a.67.67 0 0 0 .7 0l3.885-2.344a.57.57 0 0 0 .265-.49v-.359a.32.32 0 0 0-.236-.315l-.127-.028a20 20 0 0 0-8.274 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const OneAgentSignetIcon = /* @__PURE__ */ Object.assign(
  OneAgentSignetIconComponent,
  { displayName: 'OneAgentSignetIcon' },
);
